import GLightbox from 'glightbox';

const initGalleryLightbox = () => {
  const galleries = document.querySelectorAll( '.wp-block-gallery' );

  if ( ! galleries.length ) {
    return;
  }

  galleries.forEach( ( gallery, galleryIndex ) => {
    const images = gallery.querySelectorAll( 'img' );

    images.forEach( ( img ) => {
      img.style.cursor = 'pointer';
      img.addEventListener( 'click', () => {
        const items = Array.from( images ).map( ( i ) => ( {
          href: i.src,
          type: 'image',
        } ) );

        GLightbox( {
          elements: items,
          startAt: Array.from( images ).indexOf( img ),
        } ).open();
      } );
    } );
  } );
};

export default initGalleryLightbox;
